export default function Card({ key, title, content, imgUrl }) {
  return (
    <div className="row mb-5" key={key}>
      <div className="col-12 col-xl-3">
        <img alt={title} className="thumbnail img-fluid" src={imgUrl} />
      </div>
      <div className="col-12 col-xl-9">
        <h2 className="txt-white">{title}</h2>
        <p>{content}</p>
      </div>
    </div>
  );
}
